import { Injectable, HostListener, OnDestroy } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import 'rxjs/Rx';

import { AppConfigService } from '../app.config';

@Injectable()
export class SearchService {

    _error$: Subject<any> = <Subject<any>>new Subject();
    _collection$: Subject<any[]> = <Subject<any[]>>new Subject();
    _item$: Subject<any> = <Subject<any>>new Subject();
    _forms$: Subject<any[]> = <Subject<any[]>>new Subject();

    get collection$() { return this._collection$.asObservable(); }
    get item$() { return this._item$.asObservable(); }
    get error$() { return this._error$.asObservable(); }
    get forms$() { return this._forms$.asObservable(); }

    constructor(private config: AppConfigService, private http: Http) {}
    searchEmail(value: string) {
        this.http.get(`${this.config.url}/person-email/${value}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    searchName(name: string) {
        this.http.get(`${this.config.url}/person/${name}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    searchId(value: string) {
        this.http.get(`${this.config.url}/person-id/${value}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    details(value: string) {
        this.http.get(`${this.config.url}/person-detail/${value}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any) => {
                this._item$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    forms(personId: number) {
        this.http.get(`${this.config.url}/person-forms/${personId}`,
        {headers: this.getHeaders()}).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._forms$.next(data);
            },
            (error: any) => {
                console.log(`Could not load forms.`, error);
                this._error$.next(error);
            });
    }

    getHeaders(): Headers {
        const contentHeaders = new Headers();
        contentHeaders.append('Accept', 'application/json');
        contentHeaders.append('Content-Type', 'application/json');
        contentHeaders.append('Authorization', this.config.token);
        return  contentHeaders;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/search.ts